import { OfferedService } from "utils/interfaces"
import { allPages, pagesWithSkippedCards, timeRequestFlow } from "modules/Booking/common/constants"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

export function getAmountOfPages(
    serviceGroups: ServicesGroup[],
    isBookingAvailable: boolean,
    lastService?: OfferedService,
    hasSlots?: boolean
) {
    if (!hasSlots) {
        return timeRequestFlow
    }
    if (lastService && serviceGroups.length !== 1) return allPages
    if (
        (serviceGroups.length === 1 &&
            serviceGroups.some((g) => g.availableStatusWithCompany.ok)) ||
        lastService
    )
        return pagesWithSkippedCards
    return allPages
}
